import { useAppTheme } from "@hooks/useAppTheme";
import { Box } from "@memorang/ui";
import type { StyleProp, ViewStyle } from "react-native";
import { Chip } from "react-native-paper";

type ModuleMetadataChipsProps = {
	typeLabel?: string;
	durationLabel?: string;
	style?: StyleProp<ViewStyle>;
};

const metadataChipStyle = {
	alignSelf: "flex-start" as const,
	height: 28,
	justifyContent: "center" as const,
};

export const ModuleMetadataChips = ({
	typeLabel,
	durationLabel,
	style,
}: ModuleMetadataChipsProps) => {
	const theme = useAppTheme();

	return (
		<Box
			flexDirection="row"
			flexWrap="wrap"
			alignItems="center"
			style={[{ gap: 6 }, style]}
		>
			{typeLabel ? (
				<Chip
					compact={true}
					textStyle={{
						fontSize: 11,
						fontWeight: "600",
						lineHeight: 14,
						color: theme.colors.onSurfaceVariant,
					}}
					style={{
						...metadataChipStyle,
						backgroundColor: theme.colors.surfaceVariant,
						borderRadius: theme.roundness,
					}}
				>
					{typeLabel}
				</Chip>
			) : null}
			{durationLabel ? (
				<Chip
					compact={true}
					textStyle={{
						fontSize: 11,
						fontWeight: "600",
						lineHeight: 14,
						color: theme.colors.primary,
					}}
					style={{
						...metadataChipStyle,
						backgroundColor: theme.colors.surfaceVariant,
						borderRadius: theme.roundness,
					}}
				>
					{durationLabel}
				</Chip>
			) : null}
		</Box>
	);
};
